// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
import { LogStatsViewServerFragmentDoc } from "./LogStatsView.v2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type LogInsightsV2QueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  from?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  to?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type LogInsightsV2Query = {
  __typename?: "RootQuery";
  server: {
    __typename?: "Server";
    id: string;
    systemType?: string | null;
    status: { __typename?: "ServerStatus"; integratedLogInsights: boolean };
    collector: {
      __typename?: "CollectorInfo";
      logCollectionDisabled: boolean;
      logCollectionDisabledReason?: string | null;
    };
    localCollector?: {
      __typename?: "LocalCollectorInfo";
      enableLogs?: boolean | null;
    } | null;
    logStats: Array<{
      __typename?: "LogStat";
      bucketStart: string;
      classification?: string | null;
      count: number;
    }>;
    logQuota: { __typename?: "LogQuota"; overQuotaBytes: number };
  };
};

export const LogInsightsV2Document = gql`
  query LogInsightsV2(
    $serverId: ID!
    $from: Timestamp
    $to: Timestamp
    $databaseId: ID
  ) {
    server(id: $serverId) {
      id
      systemType
      status {
        integratedLogInsights
      }
      collector {
        logCollectionDisabled
        logCollectionDisabledReason
      }
      localCollector {
        enableLogs
      }
      ...LogStatsViewServer
    }
  }
  ${LogStatsViewServerFragmentDoc}
`;

/**
 * __useLogInsightsV2Query__
 *
 * To run a query within a React component, call `useLogInsightsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLogInsightsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogInsightsV2Query({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useLogInsightsV2Query(
  baseOptions: Apollo.QueryHookOptions<
    LogInsightsV2Query,
    LogInsightsV2QueryVariables
  > &
    (
      | { variables: LogInsightsV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogInsightsV2Query, LogInsightsV2QueryVariables>(
    LogInsightsV2Document,
    options,
  );
}
export function useLogInsightsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogInsightsV2Query,
    LogInsightsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogInsightsV2Query, LogInsightsV2QueryVariables>(
    LogInsightsV2Document,
    options,
  );
}
// @ts-ignore
export function useLogInsightsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LogInsightsV2Query,
    LogInsightsV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LogInsightsV2Query,
  LogInsightsV2QueryVariables
>;
export function useLogInsightsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogInsightsV2Query,
        LogInsightsV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LogInsightsV2Query | undefined,
  LogInsightsV2QueryVariables
>;
export function useLogInsightsV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogInsightsV2Query,
        LogInsightsV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LogInsightsV2Query,
    LogInsightsV2QueryVariables
  >(LogInsightsV2Document, options);
}
export type LogInsightsV2QueryHookResult = ReturnType<
  typeof useLogInsightsV2Query
>;
export type LogInsightsV2LazyQueryHookResult = ReturnType<
  typeof useLogInsightsV2LazyQuery
>;
export type LogInsightsV2SuspenseQueryHookResult = ReturnType<
  typeof useLogInsightsV2SuspenseQuery
>;
export type LogInsightsV2QueryResult = Apollo.QueryResult<
  LogInsightsV2Query,
  LogInsightsV2QueryVariables
>;
